import React from "react";
import "./CaseStudies.css";

const CASES = [
  {
    title: "TikTok Viral Campaign",
    description: "Achieved 2M+ views and 50K+ conversions within 2 weeks.",
    metric: "2M+ Views",
    image: "/assets/case-tiktok.jpg", // Replace with your image
  },
  {
    title: "Google Ads ROI Boost",
    description: "Increased client ROI by 150% through smart ad targeting.",
    metric: "150% ROI",
    image: "/assets/case-google.jpg",
  },
  {
    title: "YouTube Video Ads",
    description: "Generated 500K+ watch hours with just $5k budget.",
    metric: "500K+ Hours",
    image: "/assets/case-youtube.jpg",
  },
];

export default function CaseStudies() {
  return (
    <section className="case-studies" id="case-studies">
      <div className="case-studies__inner">
        <h2 className="case-studies__title">
          Our <span>Case Studies</span>
        </h2>
        <p className="case-studies__subtitle">
          Real success stories from our advertising campaigns — proven results
          that drive business growth.
        </p>

        <div className="case-studies__grid">
          {CASES.map((caseItem, index) => (
            <div className="case-card" key={index}>
              <div className="case-image">
                <img src={caseItem.image} alt={caseItem.title} />
              </div>
              <div className="case-content">
                <h3>{caseItem.title}</h3>
                <p>{caseItem.description}</p>
                <span className="case-metric">{caseItem.metric}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
